<template>
  <button
    type="button"
    class="flex w-full items-center justify-center rounded-button border border-border-medium bg-background px-10 py-2 text-button-m font-medium transition-colors hover:bg-background-light active:bg-background-light"
    @click="googleLogin"
  >
    <Icon name="google" class="mr-3 size-6" /> {{ props.type === 'register' ? t['w.global.register_google']() : t['w.global.login-google']() }}
  </button>
</template>

<script setup lang="ts">
import * as t from '~/messages'
import { useGoogleLogin } from '~/composables/google-login'

const props = withDefaults(
  defineProps<{
    type?: 'login' | 'register'
  }>(),
  {
    type: 'login',
  }
)

const { login: googleLogin } = useGoogleLogin()
</script>
